<template>
  <v-container class="twilio-whatsapp-shell pa-0" fluid @keydown.ctrl="abrirPegar">
    <v-card class="twilio-whatsapp-app elevation-6">
      <v-row class="ma-0 fill-height twilio-whatsapp-row">
        <v-col
          cols="12"
          sm="6"
          class="pa-0 twilio-whatsapp-sidebar"
          :class="{ 'wa-panel-hidden': isMobileLayout && chat }"
        >
          <div class="wa-sidebar-header">
            <div class="d-flex align-center wa-header-actions">
              <v-avatar color="#00a884" size="42">
                <v-icon color="white">mdi-whatsapp</v-icon>
              </v-avatar>
              <div class="ml-3">
                <div class="wa-title">Twilio Fast</div>
                <div class="wa-subtitle" v-if="filtroVendedora">{{ filtroVendedora.nombre }}</div>
                <div class="wa-subtitle" v-else>{{ filterChats.length }} conversaciones</div>
              </div>
            </div>

            <div class="d-flex align-center">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn icon small v-bind="attrs" v-on="on" @click="dialogSeguimiento.estatus = true">
                    <v-icon color="#54656f">mdi-information-outline</v-icon>
                  </v-btn>
                </template>
                <span>Información de seguimiento</span>
              </v-tooltip>

              <v-menu
                v-if="[334,1,568,32,718,1183,1258,2155,2268,2269,2342,954,2472,2556,2230,2767,2910,1312,2548].includes(getdatosUsuarioERPERP.iderp) || vendedorasTwilio.length"
                bottom
                offset-y
              >
                <template v-slot:activator="{ on: menuOn, attrs: menuAttrs }">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on: tooltipOn, attrs: tooltipAttrs }">
                      <v-btn icon small v-bind="{ ...menuAttrs, ...tooltipAttrs }" v-on="{ ...menuOn, ...tooltipOn }">
                        <v-icon color="#54656f">mdi-account-switch-outline</v-icon>
                      </v-btn>
                    </template>
                    <span>Filtrar por vendedora</span>
                  </v-tooltip>
                </template>

                <v-list dense>
                  <v-list-item
                    v-for="(item, index) in listaVendedoras"
                    :key="index"
                    @click="filtroVendedora = item"
                  >
                    <v-list-item-icon class="mr-2">
                      <v-icon color="#00a884">mdi-account</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title class="text-caption">{{ item.nombre }}</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>

              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn icon small v-bind="attrs" v-on="on" @click="initialize(2)">
                    <v-icon color="#54656f">mdi-refresh</v-icon>
                  </v-btn>
                </template>
                <span>Actualizar chats</span>
              </v-tooltip>
            </div>
          </div>

          <div class="wa-search-panel">
            <v-text-field
              :readonly="filterChats ? false : true"
              v-model="buscarUsuario"
              hide-details
              dense
              solo
              flat
              clearable
              rounded
              :autofocus="buscarUsuarioActive"
              prepend-inner-icon="mdi-magnify"
              placeholder="Buscar o iniciar un chat"
              class="wa-search"
              @input="programarValidacionBusquedaCerrado"
              @keyup.enter="onEnterBusqueda"
              @click:clear="avisoBusquedaCerrado = null"
            ></v-text-field>

            <v-alert
              v-if="avisoBusquedaCerrado"
              dense
              text
              colored-border
              border="left"
              type="warning"
              dismissible
              class="mt-2 mb-1"
              @input="avisoBusquedaCerrado = null"
            >
              <span class="font-weight-bold">{{ avisoBusquedaCerrado }}</span>
            </v-alert>

            <v-progress-linear
              v-if="cargandoBusquedaCerrado"
              indeterminate
              color="#00a884"
              height="2"
              class="mx-2"
            ></v-progress-linear>

            <div class="wa-filter-row">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn fab small class="wa-filter-btn" :color="filtroFuego ? 'red' : 'white'" v-bind="attrs" v-on="on" @click="activarFiltroTemperatura('fuego')">
                    <div class="text-h6">🔥</div>
                  </v-btn>
                </template>
                <span>Chats calientes</span>
              </v-tooltip>

              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn fab small class="wa-filter-btn" :color="filtroHielo ? 'blue' : 'white'" v-bind="attrs" v-on="on" @click="activarFiltroTemperatura('hielo')">
                    <div class="text-h6">🧊</div>
                  </v-btn>
                </template>
                <span>Chats fríos</span>
              </v-tooltip>

              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    small
                    :depressed="filtroRecomendados"
                    class="wa-filter-btn"
                    :class="{ 'px-3': true }"
                    :fab="!filtroRecomendados"
                    :rounded="filtroRecomendados"
                    :color="filtroRecomendados ? 'deep-purple' : 'white'"
                    :dark="filtroRecomendados"
                    v-bind="attrs"
                    v-on="on"
                    @click="filtroRecomendados = !filtroRecomendados"
                  >
                    <span class="text-caption font-weight-bold" :class="filtroRecomendados ? '' : 'purple--text text--darken-2'">rec</span>
                  </v-btn>
                </template>
                <span>Solo recomendados</span>
              </v-tooltip>

              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn fab small class="wa-filter-btn" :color="filtroMensajes ? 'red lighten-4' : 'white'" v-bind="attrs" v-on="on" @click="filtroMensajes = true">
                    <v-icon color="red">mdi-message-badge</v-icon>
                  </v-btn>
                </template>
                <span>Chats con 4 o más mensajes</span>
              </v-tooltip>

              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn rounded class="wa-filter-clear" v-bind="attrs" v-on="on" @click="limpiarFiltros">
                    Todos!!
                  </v-btn>
                </template>
                <span>Quitar filtros y ver todos</span>
              </v-tooltip>

              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    fab
                    small
                    class="wa-filter-btn"
                    :color="filtroVistos ? 'grey darken-2' : 'white'"
                    v-bind="attrs"
                    v-on="on"
                    @click="filtroVistos = true"
                  >
                    <v-icon :color="filtroVistos ? 'white' : 'grey darken-2'">mdi-message-bulleted-off</v-icon>
                  </v-btn>
                </template>
                <span>Chats sin responder</span>
              </v-tooltip>

              <v-menu bottom offset-y>
                <template v-slot:activator="{ on: menuOn, attrs: menuAttrs }">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on: tooltipOn, attrs: tooltipAttrs }">
                  <v-btn fab small color="white" class="wa-filter-btn" v-bind="{ ...menuAttrs, ...tooltipAttrs }" v-on="{ ...menuOn, ...tooltipOn }">
                    <v-icon :color="etiqueta ? etiqueta.color : 'grey darken-2'">mdi-checkbox-blank-circle</v-icon>
                  </v-btn>
                    </template>
                    <span>Filtrar por etiqueta</span>
                  </v-tooltip>
                </template>

                <v-list dense>
                  <v-list-item
                    v-for="(item, index) in etiquetas"
                    :key="index"
                    @click="etiqueta = item"
                  >
                    <v-list-item-title class="text-caption">
                      <v-icon small :color="item.color">mdi-label</v-icon>
                      {{ item.text }}
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>

              <v-menu bottom offset-y>
                <template v-slot:activator="{ on: menuOn, attrs: menuAttrs }">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on: tooltipOn, attrs: tooltipAttrs }">
                  <v-btn fab small color="white" class="wa-filter-btn" v-bind="{ ...menuAttrs, ...tooltipAttrs }" v-on="{ ...menuOn, ...tooltipOn }">
                    <v-icon :color="filtroTiempo ? filtroTiempo.color : 'grey darken-2'">mdi-clock</v-icon>
                  </v-btn>
                    </template>
                    <span>Filtrar por tiempo</span>
                  </v-tooltip>
                </template>

                <v-list dense>
                  <v-list-item
                    v-for="(item, index) in tiempos"
                    :key="index"
                    @click="filtroTiempo = item"
                  >
                    <v-list-item-title class="text-caption">
                      <v-icon small :color="item.color">mdi-clock</v-icon>
                      {{ item.text }}
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>

              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <div class="wa-select-tooltip" v-bind="attrs" v-on="on">
              <v-select
                v-if="accesosBoton"
                class="wa-select wa-incompletos-select"
                dense
                hide-details
                solo
                flat
                rounded
                :items="opcionesIncompletos"
                label="Incompletos"
                v-model="filtroIncompletos"
                item-value="value"
                item-text="text"
                clearable
              ></v-select>
                  </div>
                </template>
                <span>Filtrar chats incompletos</span>
              </v-tooltip>
            </div>
          </div>

          <div id="preguntas" ref="chatList" class="wa-chat-list">
            <div
              v-for="(chatW, i) in filterChats"
              v-if="i <= limite"
              :key="chatW.usuario"
              :class="['wa-contact', { 'wa-contact-active': chatEstaActivo(chatW) }]"
              @click="verChat(chatW)"
            >
              <div class="wa-contact-avatar-wrap">
                <v-badge
                  :value="chatW.totalMensajes >= 4"
                  color="#f15c6d"
                  dot
                  offset-x="8"
                  offset-y="8"
                >
                  <v-avatar :color="!chatW.nombre ? '#00a884' : '#dfe5e7'" size="48">
                    <v-icon color="white" v-if="!chatW.nombre">mdi-account</v-icon>
                    <span v-else class="wa-avatar-text">{{ chatW.nombre }}</span>
                  </v-avatar>
                </v-badge>
              </div>

              <div class="wa-contact-body">
                <div class="wa-contact-top">
                  <div class="wa-contact-name">
                    <v-icon small v-if="chatW.idetiquetas" :color="chatW.color">mdi-label</v-icon>
                    <v-icon x-small color="orange" v-if="chatW.reasignado">mdi-circle</v-icon>
                    {{ tituloListaChat(chatW) }}
                  </div>
                  <div class="wa-contact-time">{{ horaChat(chatW) }}</div>
                </div>

                <div class="wa-contact-middle" v-if="subtituloListaChat(chatW)">
                  {{ subtituloListaChat(chatW) }}
                </div>

                <div class="wa-contact-bottom">
                  <div class="wa-last-message">
                    <v-icon small class="mr-1" v-if="chatW.mio" color="#8696a0">mdi-check-all</v-icon>
                    {{ resumenMensaje(chatW) }}
                  </div>
                  <div class="wa-contact-badges">
                    <v-chip
                      v-if="chatW.city"
                      x-small
                      label
                      dark
                      :color="chipCityColor(chatW)"
                    >
                      {{ chatW.city.toUpperCase() }}
                    </v-chip>
                    <v-chip
                      v-if="Number(chatW.es_recomendado) === 1"
                      x-small
                      label
                      dark
                      color="deep-purple"
                      title="Recomendado"
                    >
                      rec
                    </v-chip>
                    <v-chip
                      v-if="chatW.tiemporestante !== undefined && chatW.tiemporestante !== null"
                      x-small
                      label
                      dark
                      class="wa-time-chip"
                      :color="tiempoColor(chatW)"
                    >
                      {{ chatW.tiemporestante }}
                      <v-icon x-small right>mdi-clock</v-icon>
                    </v-chip>
                    <span v-if="chatW.sinleer > 0 || chatW.mio == 0" class="wa-unread">
                      {{ chatW.sinleer > 0 ? chatW.sinleer : 1 }}
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <div v-if="mostrarCargarMas" class="pa-3">
              <v-btn color="#00a884" dark block rounded depressed @click="onCargarMasChats">
                Mostrar más conversaciones
              </v-btn>
            </div>
          </div>
        </v-col>

        <v-col
          cols="12"
          sm="6"
          class="pa-0 twilio-whatsapp-conversation"
          :class="{ 'wa-panel-hidden': isMobileLayout && !chat }"
        >
          <div v-if="!chat" class="wa-empty-state">
            <v-icon size="96" color="#d1d7db">mdi-whatsapp</v-icon>
            <h2>WhatsApp CRM</h2>
            <p>Selecciona un chat para ver la conversación en tiempo real.</p>
          </div>

          <template v-else>
            <div class="wa-chat-header">
              <div class="d-flex align-center overflow-hidden">
                <v-btn
                  v-if="isMobileLayout"
                  icon
                  small
                  class="mr-2 wa-back-btn"
                  @click="cerrarChatMobile"
                >
                  <v-icon color="#54656f">mdi-arrow-left</v-icon>
                </v-btn>
                <v-avatar :color="!chat.nombre ? '#00a884' : '#dfe5e7'" size="44">
                  <v-icon color="white" v-if="!chat.nombre">mdi-account</v-icon>
                  <span v-else class="wa-avatar-text">{{ chat.nombre }}</span>
                </v-avatar>
                <div class="ml-3 overflow-hidden">
                  <div class="wa-chat-title-stack">
                    <div class="wa-copy-row">
                      <span class="wa-chat-name">{{ nombreContacto(chat) }}</span>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn icon x-small class="wa-copy-btn" v-bind="attrs" v-on="on" @click="copiarTexto(telefonoContacto(chat), 'Número copiado')">
                            <v-icon small color="#667781">mdi-content-copy</v-icon>
                          </v-btn>
                        </template>
                        <span>Copiar número</span>
                      </v-tooltip>
                    </div>
                    <div v-if="chat.folio" class="wa-copy-row">
                      <span class="wa-chat-folio">Folio {{ chat.folio }}</span>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn icon x-small class="wa-copy-btn" v-bind="attrs" v-on="on" @click="copiarTexto(chat.folio, 'Folio copiado')">
                            <v-icon small color="#667781">mdi-content-copy</v-icon>
                          </v-btn>
                        </template>
                        <span>Copiar folio</span>
                      </v-tooltip>
                    </div>
                  </div>
                  <div class="wa-chat-meta">
                    <span v-if="!chat.folio">Sin prospecto asignado</span>
                    <span v-if="chat.city">{{ !chat.folio ? ' · ' : '' }}{{ chat.city.toUpperCase() }}</span>
                  </div>
                </div>
              </div>

              <div class="wa-chat-actions">
                <v-tooltip
                  v-if="[1,3,568,334,2268,2155,2472,2556,2230,954,2767,2910,1312].includes(getdatosUsuarioERPERP.iderp) && chat.folio"
                  bottom
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      small
                      rounded
                      depressed
                      color="#ffffff"
                      class="wa-action-btn"
                      v-bind="attrs"
                      v-on="on"
                      @click="dialogReasignar.estatus = true"
                    >
                      <v-icon small left>mdi-account-switch</v-icon>
                      Reasignar
                    </v-btn>
                  </template>
                  <span>Reasignar prospecto</span>
                </v-tooltip>

                <v-tooltip
                  v-if="[1,3,568,334,2268,2155,2472,2556,2230,954,2767,2910,1312].includes(getdatosUsuarioERPERP.iderp) && !chat.folio"
                  bottom
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      small
                      rounded
                      depressed
                      color="#ffffff"
                      class="wa-action-btn"
                      v-bind="attrs"
                      v-on="on"
                      @click="dialogAsignar.estatus = true"
                    >
                      <v-icon small left>mdi-account-plus</v-icon>
                      Asignar
                    </v-btn>
                  </template>
                  <span>Asignar prospecto</span>
                </v-tooltip>

                <v-menu v-if="chat.idetiquetas != 6" top offset-y>
                  <template v-slot:activator="{ on: menuOn, attrs: menuAttrs }">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on: tooltipOn, attrs: tooltipAttrs }">
                        <v-btn
                          icon
                          small
                          v-bind="{ ...menuAttrs, ...tooltipAttrs }"
                          v-on="{ ...menuOn, ...tooltipOn }"
                        >
                          <v-icon color="#54656f">mdi-label-outline</v-icon>
                        </v-btn>
                      </template>
                      <span>Cambiar categoría</span>
                    </v-tooltip>
                  </template>

                  <v-list dense>
                    <v-list-item
                      v-for="(item, index) in etiquetas2"
                      :key="index"
                      @click="cambiarCategoria(item.idetiquetas)"
                    >
                      <v-list-item-title class="text-caption">
                        <v-icon small :color="item.color">mdi-label</v-icon>
                        {{ item.text }}
                      </v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>

                <v-tooltip bottom color="blue">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      icon
                      small
                      v-bind="attrs"
                      v-on="on"
                      @click="dialogComentariosAbiertoChat = true"
                    >
                      <v-icon color="#54656f">mdi-comment-plus-outline</v-icon>
                    </v-btn>
                  </template>
                  <span>Agregar comentario</span>
                </v-tooltip>

                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn icon small v-bind="attrs" v-on="on" @click="dialogDescrip = true">
                      <v-icon color="#54656f">mdi-dots-vertical</v-icon>
                    </v-btn>
                  </template>
                  <span>Ver etiquetas</span>
                </v-tooltip>
              </div>
            </div>

            <section class="wa-chat-area">
              <v-container
                id="scroll-target"
                class="wa-messages-scroll overflow-y-auto elevation-0"
              >
                <MensajesWppTwilio
                  class="messages-chat elevation-0"
                  id="mensajesChat"
                  :mensajes="mensajes"
                  :alumno="alumno"
                  :wha="wha"
                  :chat="chat"
                  :verTodosLosMensajes="verTodosLosMensajes"
                  :asignacion="asignacion"
                  :numeroTwilio="numeroTwilio"
                  :composerDeshabilitadoPorControl="chatSoloLecturaCerrado"
                  :mensajeComposerDeshabilitado="chatSoloLecturaCerrado ? 'Contacto bloqueado (spam) — solo lectura' : ''"
                  :chats="getConversacionesFast"
                  @validayGuardaMensajes="validayGuardaMensajes"
                  @verChat="verChat"
                />
              </v-container>
            </section>
          </template>
        </v-col>
      </v-row>
    </v-card>

    <v-dialog v-model="dialogDescrip" max-width="500px" transition="dialog-transition">
      <v-card>
        <v-card-title primary-title>Etiquetas</v-card-title>
        <v-card-text class="black--text">
          <div v-for="(etiquetaItem, i) in etiquetas" :key="i">
            <v-icon :color="etiquetaItem.color">mdi-label</v-icon>
            <b>{{ etiquetaItem.etiqueta }}</b>
            <br/>
            {{ etiquetaItem.detalles }}
            <br/>
            <br/>
            <v-divider></v-divider>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogComentariosAbiertoChat" max-width="600px" scrollable>
      <v-card v-if="chat && chat.idprospectos">
        <v-card-title class="headline">
          <v-icon small class="mr-2">mdi-chat-multiple</v-icon>
          Comentarios del Prospecto
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text style="min-height: 400px;">
          <ComentariosProspecto :idProspecto="chat.idprospectos" />
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="dialogComentariosAbiertoChat = false">
            <v-icon small class="mr-1">mdi-close</v-icon>
            Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <ReasignarProspecto
      v-if="dialogReasignar.estatus"
      :dialogReasignar="dialogReasignar"
      :alumno="alumno"
      :wha="wha"
      :chat="chat"
    />

    <AsignarProspecto
      v-if="dialogAsignar.estatus"
      :escuela="2"
      :dialogAsignar="dialogAsignar"
      :alumno="alumno"
      :wha="wha"
      :chat="chat"
    />

    <InfoSeguimiento
      v-if="dialogSeguimiento.estatus"
      :dialogSeguimiento="dialogSeguimiento"
    />

    <Alerta v-if="respuestaAlerta" :parametros="parametros"/>
    <carga v-if="cargar"/>
  </v-container>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'

  import Alerta from '@/components/alertas/Alerta.vue'
  import carga from '@/components/alertas/carga.vue'
  import MensajesWppTwilio from '@/components/whatsapp/MensajesTwilioWpp.vue'
  import ReasignarProspecto from '@/components/whatsapp/ReasignarProspecto.vue'
  import InfoSeguimiento from '@/components/whatsapp/InfoSeguimiento.vue'
  import AsignarProspecto from '@/components/whatsapp/AsignarProspecto.vue'
  import ComentariosProspecto from '@/components/ComentariosProspecto.vue'

  import validarErrores from '@/mixins/validarErrores'
  import mixinWhatsApp from '@/mixins/mixinWhatsApp'
  import mixinEstatusWha from '@/mixins/mixinEstatusWha'
  import mixinExamenTwilioAbrir from '@/mixins/mixinExamenTwilioAbrir'
  import { chatCoincideBusquedaTwilio } from '@/utils/examenUbicacionNotify'

  export default {
    name: 'TwilioFastWhatsApp',

    components: {
      Alerta,
      carga,
      MensajesWppTwilio,
      ReasignarProspecto,
      InfoSeguimiento,
      AsignarProspecto,
      ComentariosProspecto,
    },

    mixins: [validarErrores, mixinEstatusWha, mixinWhatsApp, mixinExamenTwilioAbrir],

    data: () => ({
      skipMixinWhatsAppInit: true,
      dialogDescrip: false,
      dialogComentariosAbiertoChat: false,
      buscarPregunta: '',
      buscarActive: false,
      parametros: {
        dialogError: false,
        mensaje: '',
        color: '',
      },
      respuestaAlerta: false,
      cargar: false,
      cargarMensajes: false,
      pendingChatListScroll: null,
      lastChatListScroll: null,
      usuarios: [],
      usuario: null,
      buscarUsuario: '',
      buscarUsuarioActive: true,
      alumno: null,
      url: 'https://escuelakpi.club/kpi/whatsapp-imagenes/',
      notSeen: false,
      searchMensaje: '',
      mensajes: [],
      chat: null,
      wha: null,
      notResponse: false,
      verTodosLosMensajes: 0,
      message: '',
      parametrosAsignarVendedora: {
        estatus: false,
      },
      asignacion: null,
      conversaciones: [],
      asignados: [],
      loader: true,
      sonido: null,
      numeroTwilio: 'whatsapp:+5218123255321',
      offsetTop: 0,
      limite: 30,
      chatsApiPageSize: 100,
      chatsPagination: null,
      cargandoMasChats: false,
      filtroFuego: false,
      filtroSinProspecto: false,
      filtroSinProspectoNoInteres: false,
      filtroHielo: false,
      filtroRecomendados: false,
      filtroMensajes: false,
      filtroVistos: false,
      filtroIncompletos: null,
      opcionesIncompletos: [
        { text: 'Incompletos con interés', value: 'con_interes' },
        { text: 'Incompletos sin interés', value: 'sin_interes' },
        { text: 'Sin incompletos', value: 'sin_incompletos' },
      ],
      etapa: 8,
      etiqueta: null,
      filtroTiempo: false,
      escuela: '2',
      filtroVendedora: null,
      vendedoras_plantel: [],
      dialogReasignar: {
        estatus: false,
      },
      dialogSeguimiento: {
        estatus: false,
      },
      dialogAsignar: {
        estatus: false,
      },
      timerBusquedaServidor: null,
      reqBusquedaServidor: 0,
      cargandoBusquedaServidor: false,
      avisoBusquedaCerrado: null,
      cargandoBusquedaCerrado: false,
      timerBusquedaCerrado: null,
      reqBusquedaCerrado: 0,
    }),

    computed: {
      ...mapGetters('login', ['getdatosUsuarioERPERP']),
      ...mapGetters('twilio', ['getConversacionesM', 'getConversacionesC', 'getConversacionesG', 'getConversacionesFast']),

      accesosBoton () {
        return [568,334,1,32,2556,2230,954,2767,2910,1312].includes(this.getdatosUsuarioERPERP.iderp)
      },

      /** Spam bloqueado: ver historial sin enviar. Ventana 24h la maneja MensajesTwilioWpp (tiemporestante). */
      chatSoloLecturaCerrado () {
        return !!(this.chat && Number(this.chat.idetiquetas) === 6)
      },

      listaVendedoras () {
        return this.vendedorasTwilio.length ? this.vendedorasTwilio : this.vendedoras_plantel
      },

      filterChats () {
        let chats = (this.getConversacionesFast && this.getConversacionesFast.length)
          ? this.getConversacionesFast
          : (Array.isArray(this.conversaciones) ? this.conversaciones : [])

        if (this.buscarUsuario) {
          const q = String(this.buscarUsuario).trim()
          chats = chats.filter(el => chatCoincideBusquedaTwilio(el, q))
        }

        chats = chats.sort((a, b) => {
          if (b.sinleer !== a.sinleer) {
            return b.sinleer - a.sinleer
          }

          const fb = b.fecha_ultimo_mensaje || b.ultimmensaje || b.ultimomensaje || ''
          const fa = a.fecha_ultimo_mensaje || a.ultimmensaje || a.ultimomensaje || ''
          return new Date(fb) - new Date(fa)
        })

        if (this.filtroFuego && !this.filtroHielo) {
          chats = chats.filter(el => el.nombre == '🔥')
        }

        if (this.filtroMensajes) {
          chats = chats.filter(el => Number(el.totalMensajes) >= 4)
        }

        if (this.filtroHielo && !this.filtroFuego) {
          chats = chats.filter(el => el.nombre == '🧊')
        }

        if (this.filtroRecomendados) {
          chats = chats.filter(el => Number(el.es_recomendado) === 1)
        }

        if (this.etapa && this.etapa != 8) {
          chats = chats.filter(el => el.idetapa == this.etapa)
        }

        if (this.filtroVistos) {
          chats = chats.filter(el => el.mio == 0)
        }

        if (this.etiqueta) {
          chats = chats.filter(el => el.idetiquetas == this.etiqueta.idetiquetas)
        }

        if (this.filtroIncompletos) {
          if (this.filtroIncompletos == 'con_interes') {
            chats = chats.filter(el => !el.folio && Number(el.totalMensajes) >= 2)
          } else if (this.filtroIncompletos == 'sin_interes') {
            chats = chats.filter(el => !el.folio && Number(el.totalMensajes) < 2)
          } else if (this.filtroIncompletos == 'sin_incompletos') {
            chats = chats.filter(el => el.folio)
          }
        }

        if (this.filtroTiempo) {
          if (this.filtroTiempo.idtiempos == 1) {
            chats = chats.filter(el => el.tiemporestante > 2)
          } else if (this.filtroTiempo.idtiempos == 2) {
            chats = chats.filter(el => el.tiemporestante > 0 && el.tiemporestante <= 2)
          } else if (this.filtroTiempo.idtiempos == 3) {
            chats = chats.filter(el => el.tiemporestante <= 0)
          }
        }

        return chats
      },

      tamanioLista () {
        return this.$vuetify.breakpoint.height - 240
      },

      tamanioMensajes () {
        return this.$vuetify.breakpoint.height - 158
      },

      mostrarCargarMas () {
        if (this.limite < this.filterChats.length) return true
        return !!(this.chatsPagination && this.chatsPagination.hasMore)
      },

      isMobileLayout () {
        return this.$vuetify.breakpoint.width < 600
      },
    },

    watch: {
      filtroVendedora () {
        this.initialize()
      },

      buscarUsuario (value) {
        this.programarBusquedaServidor(value)
        this.programarValidacionBusquedaCerrado(value)
      },

      filterChats (lista) {
        if (this._pendienteAbrirTwilioTmp && Array.isArray(lista) && lista.length) {
          this.$nextTick(() => this.intentarAbrirChatDesdeTwilioTmp())
        }
      },

      getConversacionesFast () {
        this.$nextTick(() => this.tryAbrirChatExamenPendiente())
        if (this.pendingChatListScroll != null) {
          this.restoreChatListScroll(this.pendingChatListScroll)
          this.pendingChatListScroll = null
        }
      },
    },

    async created () {
      await this.getVendedoras()
      this.crearTemplateSonido()
      this.getTwilioTmp()
      this.initialize(2)
      this.syncPendingExamenDesdeRuta()
    },

    methods: {
      examenListasChats () {
        return [this.getConversacionesFast, this.conversaciones]
      },

      examenRecargarChats () {
        return this.initialize(2)
      },

      getTwilioTmp () {
        const twilioTmp = sessionStorage.getItem('twilioTmp')
        if (twilioTmp) {
          this.buscarUsuario = twilioTmp
          sessionStorage.removeItem('twilioTmp')
          if (sessionStorage.getItem('twilioTmpAutoOpen') === '1') {
            this._pendienteAbrirTwilioTmp = String(twilioTmp).trim()
            sessionStorage.removeItem('twilioTmpAutoOpen')
            this.$nextTick(() => this.intentarAbrirChatDesdeTwilioTmp())
          }
        }
      },

      intentarAbrirChatDesdeTwilioTmp () {
        const q = this._pendienteAbrirTwilioTmp
        if (!q) return
        const lista = Array.isArray(this.filterChats) ? this.filterChats : []
        const match = lista.find((chat) => chatCoincideBusquedaTwilio(chat, q))
        if (match) {
          this._pendienteAbrirTwilioTmp = null
          this.verChat(match)
        }
      },

      programarBusquedaServidor (value) {
        if (this.timerBusquedaServidor) {
          clearTimeout(this.timerBusquedaServidor)
          this.timerBusquedaServidor = null
        }

        const q = String(value || '').trim()
        if (!q || q.length < 4) return

        this.timerBusquedaServidor = setTimeout(() => {
          this.buscarChatEnServidor(q)
        }, 450)
      },

      async buscarChatEnServidor (value, forzar = false) {
        const query = String(value || '').trim()
        if (!query || query.length < 4) return
        if (String(this.buscarUsuario || '').trim() !== query) return

        // Si ya está en la lista cargada, no llamar al API
        if (!forzar) {
          const locales = [
            ...(Array.isArray(this.getConversacionesFast) ? this.getConversacionesFast : []),
            ...(Array.isArray(this.conversaciones) ? this.conversaciones : []),
          ]
          if (locales.some(chat => chatCoincideBusquedaTwilio(chat, query))) return
        }

        const reqId = ++this.reqBusquedaServidor
        this.cargandoBusquedaServidor = true

        try {
          const response = await this.$http.post('twilio.chats.buscar', {
            busqueda: query,
            twilio: this.numeroTwilio,
            idusuario: this.getdatosUsuarioERPERP.iderp,
            escuela: 2,
            incluirCerrados: true,
          })

          if (reqId !== this.reqBusquedaServidor) return
          if (String(this.buscarUsuario || '').trim() !== query) return

          const data = response.data || {}
          if (!data.encontrado || !data.chat) return null

          const chat = { ...data.chat, sinleer: data.chat.sinleer || 0 }
          const yaExiste = (this.conversaciones || []).some(c => c.usuario === chat.usuario)
          if (!yaExiste) {
            this.conversaciones = [chat, ...(this.conversaciones || [])]
            this.guardarConversacionesFast(this.conversaciones)
            this.setVendedorAsignado()
          } else {
            this.conversaciones = (this.conversaciones || []).map((c) => {
              if (c.usuario !== chat.usuario) return c
              const finalizo = Number(c.finalizo) === 1 || Number(chat.finalizo) === 1 ? 1 : chat.finalizo
              return { ...c, ...chat, finalizo }
            })
            this.guardarConversacionesFast(this.conversaciones)
          }
          return chat
        } catch (error) {
          console.warn('No se pudo buscar chat por folio/teléfono', error)
          return null
        } finally {
          if (reqId === this.reqBusquedaServidor) {
            this.cargandoBusquedaServidor = false
          }
        }
      },

      onEnterBusqueda () {
        this.validarBusquedaCerradoEnBd(this.buscarUsuario)
        this.buscarChatEnServidor(this.buscarUsuario, true)
      },

      programarValidacionBusquedaCerrado (value) {
        if (this.timerBusquedaCerrado) {
          clearTimeout(this.timerBusquedaCerrado)
          this.timerBusquedaCerrado = null
        }

        const q = String(value || '').trim()
        if (!q || q.length < 4) {
          this.avisoBusquedaCerrado = null
          this.cargandoBusquedaCerrado = false
          return
        }

        this.timerBusquedaCerrado = setTimeout(() => {
          this.validarBusquedaCerradoEnBd(q)
        }, 450)
      },

      async validarBusquedaCerradoEnBd (q) {
        const query = String(q || '').trim()
        if (!query || query.length < 4) return
        if (String(this.buscarUsuario || '').trim() !== query) return

        const reqId = ++this.reqBusquedaCerrado
        this.cargandoBusquedaCerrado = true

        try {
          const avisoLocal = this.avisoCerradoDesdeChatsCargados(query)
          if (avisoLocal) {
            this.mostrarAvisoCerrado(avisoLocal)
            await this.abrirProspectoCerradoEnVista(query)
            return
          }

          let data = null
          try {
            const response = await this.$http.post('twilio.buscar.cerrado', {
              busqueda: query,
              escuela: 2,
              twilio: this.numeroTwilio,
            })
            data = response.data || {}
          } catch (errBuscar) {
            try {
              data = await this.fallbackBuscarCerradoProspectos(query)
            } catch (errFallback) {
              data = null
              console.warn('No se pudo validar prospecto cerrado', errBuscar, errFallback)
            }
          }

          if (reqId !== this.reqBusquedaCerrado) return
          if (String(this.buscarUsuario || '').trim() !== query) return

          if (data && data.cerrado) {
            this.mostrarAvisoCerrado(data.mensaje || 'Este número y folio ya está cerrado')
            await this.abrirProspectoCerradoEnVista(query, data)
          } else {
            this.avisoBusquedaCerrado = null
          }
        } catch (error) {
          if (reqId !== this.reqBusquedaCerrado) return
          this.avisoBusquedaCerrado = null
          console.warn('Error validando número/folio cerrado', error)
        } finally {
          if (reqId === this.reqBusquedaCerrado) {
            this.cargandoBusquedaCerrado = false
          }
        }
      },

      mostrarAvisoCerrado (mensaje) {
        this.avisoBusquedaCerrado = mensaje
      },

      limpiarFiltrosParaBusquedaCerrado () {
        this.filtroMensajes = false
        this.filtroHielo = false
        this.filtroFuego = false
        this.filtroVistos = false
        this.etiqueta = null
        this.filtroTiempo = null
        this.filtroSinProspecto = null
        this.filtroSinProspectoNoInteres = false
        this.filtroIncompletos = null
        this.etapa = 8
        if (this.accesosBoton) {
          this.filtroVendedora = null
        }
      },

      encontrarChatLocalPorBusqueda (query) {
        const listas = [
          ...(Array.isArray(this.getConversacionesFast) ? this.getConversacionesFast : []),
          ...(Array.isArray(this.conversaciones) ? this.conversaciones : []),
        ]
        return listas.find((chat) => chatCoincideBusquedaTwilio(chat, query)) || null
      },

      inyectarChatCerradoEnLista (chat) {
        if (!chat || !chat.usuario) return
        const arr = Array.isArray(this.conversaciones) ? [...this.conversaciones] : []
        const idx = arr.findIndex((c) => c && c.usuario === chat.usuario)
        if (idx >= 0) {
          arr[idx] = { ...arr[idx], ...chat, finalizo: 1 }
        } else {
          arr.unshift({ ...chat, finalizo: 1 })
        }
        this.conversaciones = arr
        this.guardarConversacionesFast(arr)
        this.setVendedorAsignado()
      },

      chatSintenticoDesdeCerrado (query, dataCerrado = null) {
        const tel = String(
          (dataCerrado && dataCerrado.telefono)
          || String(query).replace(/\D/g, '').slice(-10)
          || ''
        ).replace(/\D/g, '').slice(-10)
        if (!tel && !(dataCerrado && dataCerrado.folio)) return null

        return {
          usuario: tel ? `whatsapp:+521${tel}` : `folio:${(dataCerrado && dataCerrado.folio) || query}`,
          folio: (dataCerrado && dataCerrado.folio) || null,
          idprospectos: (dataCerrado && dataCerrado.idprospectos) || null,
          nombre_completo: (dataCerrado && dataCerrado.nombre_completo) || null,
          nombre: (dataCerrado && dataCerrado.nombre_completo) || null,
          usuario_asignado: (dataCerrado && dataCerrado.usuario_asignado) || null,
          finalizo: 1,
          sinleer: 0,
          tiemporestante: 0,
          totalMensajes: 0,
          mensaje: '',
          sin_historial_twilio: 1,
        }
      },

      async abrirProspectoCerradoEnVista (query, dataCerrado = null) {
        this.limpiarFiltrosParaBusquedaCerrado()

        let chat = this.encontrarChatLocalPorBusqueda(query)
        if (!chat) {
          chat = await this.buscarChatEnServidor(query, true)
        }
        if (!chat) {
          chat = this.chatSintenticoDesdeCerrado(query, dataCerrado)
        }
        if (!chat) return

        const enriquecido = {
          ...chat,
          finalizo: 1,
          folio: (dataCerrado && dataCerrado.folio) || chat.folio || null,
          idprospectos: (dataCerrado && dataCerrado.idprospectos) || chat.idprospectos || null,
          nombre_completo: (dataCerrado && dataCerrado.nombre_completo) || chat.nombre_completo || null,
        }

        this.inyectarChatCerradoEnLista(enriquecido)
        await this.$nextTick()
        this.verChat(enriquecido)
      },

      avisoCerradoDesdeChatsCargados (query) {
        const match = this.encontrarChatLocalPorBusqueda(query)
        if (!match || Number(match.finalizo) !== 1) return null
        const tel = String(match.usuario || match.telefono || '').replace(/\D/g, '').slice(-10)
        const folio = match.folio || '—'
        return `Este número ${tel || '—'} y folio ${folio} ya está cerrado`
      },

      async fallbackBuscarCerradoProspectos (query) {
        const digits = String(query).replace(/\D/g, '')
        const last10 = digits.length >= 10 ? digits.slice(-10) : ''
        const looksLikeFolio = /[A-Za-z]/.test(query)
        const payload = {
          telefono: looksLikeFolio ? '' : (last10 || query),
          folio: looksLikeFolio ? query : '',
        }
        const response = await this.$http.post('obtener.prospectos.finalizados', payload)
        const rows = Array.isArray(response.data) ? response.data : []
        const cerrado = rows.find((r) => Number(r.finalizo) === 1)
        if (!cerrado) {
          return { encontrado: rows.length > 0, cerrado: false, mensaje: null }
        }
        const tel = String(cerrado.telefono || '').replace(/\D/g, '').slice(-10)
        const folio = cerrado.folio || '—'
        return {
          encontrado: true,
          cerrado: true,
          folio,
          telefono: tel,
          idprospectos: cerrado.idprospectos,
          mensaje: `Este número ${tel || '—'} y folio ${folio} ya está cerrado`,
        }
      },

      formatearNombre (nombreCompleto) {
        if (!nombreCompleto || typeof nombreCompleto !== 'string') {
          return ''
        }

        return nombreCompleto
          .trim()
          .toLowerCase()
          .split(/\s+/)
          .map(palabra => palabra.charAt(0).toUpperCase() + palabra.slice(1))
          .join(' ')
      },

      onScroll (e) {
        this.offsetTop = e.target.scrollTop
      },

      ...mapActions('twilio', ['guardarConversaciones', 'guardarConversacionesM', 'guardarConversacionesG', 'guardarConversacionesC', 'guardarConversacionesFast']),

      parseChatsApiResponse (data) {
        if (Array.isArray(data)) {
          return {
            chats: data,
            pagination: { hasMore: false, offset: 0, returned: data.length, limit: null },
          }
        }

        var chats = data && Array.isArray(data.chats) ? data.chats : []
        return {
          chats: chats,
          pagination: (data && data.pagination) || {
            hasMore: false,
            offset: 0,
            returned: chats.length,
            limit: null,
          },
        }
      },

      setVendedorAsignado () {
        if (!Array.isArray(this.conversaciones)) return

        const lista = this.listaVendedoras
        if (lista && lista.length) {
          this.conversaciones.forEach(it => {
            const idUsuarioAsignado = Number(it.usuario_asignado)
            if (!idUsuarioAsignado) return
            const vendedor = lista.find(vp => Number(vp.iderp) === idUsuarioAsignado)
            if (vendedor) {
              it.vendedor = {
                ...vendedor,
                nombre: this.formatearNombre(vendedor.nombre),
              }
            }
          })
        }
      },

      async fetchChatsPage ({ offset = 0, escuela, numTwilio } = {}) {
        const numeroTwilio = this.numeroTwilio || numTwilio
        const payload = {
          twilio: numeroTwilio,
          idusuario: this.filtroVendedora ? this.filtroVendedora.iderp : this.getdatosUsuarioERPERP.iderp,
          escuela: escuela ? escuela : this.getEscuela,
          offset,
          limit: this.chatsApiPageSize,
        }

        const response = await this.$http.post('twilio.chats', payload)
        const parsed = this.parseChatsApiResponse(response.data)
        const chats = parsed.chats.map(it => ({ ...it, sinleer: it.sinleer || 0 }))
        return { chats, pagination: parsed.pagination }
      },

      initialize (escuela, numTwilio) {
        this.cargar = true
        this.limite = 30

        return this.fetchChatsPage({ offset: 0, escuela, numTwilio }).then(page => {
          this.conversaciones = page.chats
          this.chatsPagination = page.pagination
          this.setVendedorAsignado()
          this.guardarConversacionesFast(this.conversaciones)
          this.$nextTick(() => this.tryAbrirChatExamenPendiente())
        }).catch(error => {
          const msg =
            (error && error.response && error.response.data && error.response.data.message)
              ? error.response.data.message
              : (error && error.message)
                ? error.message
                : 'Error al obtener chats'
          this.validarError(msg)
        }).finally(() => {
          this.cargar = false
        })
      },

      async onCargarMasChats ({ limiteVisible, total } = {}) {
        if (limiteVisible != null && total != null && limiteVisible < total) {
          this.limite += 50
          return
        }

        if (this.limite < this.filterChats.length) {
          this.limite += 50
          return
        }

        const pag = this.chatsPagination
        if (!pag || !pag.hasMore || this.cargandoMasChats) return

        this.cargandoMasChats = true
        try {
          const nextOffset = (pag.offset || 0) + (pag.returned || 0)
          const page = await this.fetchChatsPage({ offset: nextOffset })
          if (!page.chats.length) return

          this.conversaciones = this.conversaciones.concat(page.chats)
          this.chatsPagination = page.pagination
          this.setVendedorAsignado()
          this.guardarConversacionesFast(this.conversaciones)
          this.limite += 50
        } catch (error) {
          console.error(error)
        } finally {
          this.cargandoMasChats = false
        }
      },

      getChatListEl () {
        return this.$refs.chatList || document.getElementById('preguntas')
      },

      saveChatListScroll () {
        const el = this.getChatListEl()
        return el ? el.scrollTop : 0
      },

      restoreChatListScroll (scrollTop) {
        const restore = () => {
          const el = this.getChatListEl()
          if (el) el.scrollTop = scrollTop
        }

        this.$nextTick(() => {
          restore()
          this.$nextTick(() => {
            requestAnimationFrame(restore)
          })
        })
      },

      scrollMensajesAlFinal () {
        this.$nextTick(() => {
          requestAnimationFrame(() => {
            const scrollTarget = document.getElementById('scroll-target')
            if (scrollTarget) {
              scrollTarget.scrollTop = scrollTarget.scrollHeight
            }
          })
        })
      },

      cerrarChatMobile () {
        this.chat = null
        this.mensajes = []
        const scrollTop = this.lastChatListScroll
        this.$nextTick(() => {
          if (scrollTop != null) {
            this.restoreChatListScroll(scrollTop)
          }
        })
      },

      verChat (chat) {
        const payload = {
          twilio: this.numeroTwilio,
          usuario: chat.usuario,
        }

        const listScrollTop = this.saveChatListScroll()
        this.lastChatListScroll = listScrollTop
        this.cargarMensajes = true
        this.mensajes = []

        return this.$http.post('twilio.chats.unico', payload).then(response => {
          this.mensajes = response.data.conversacionCompleta
          const bloqueo = response.data.bloqueo
          const conversaciones = [...this.getConversacionesFast]

          for (const i in conversaciones) {
            const { usuario } = conversaciones[i]
            if (usuario == chat.usuario) {
              conversaciones[i].sinleer = 0
            }
          }

          if (bloqueo) {
            chat.idetiquetas = 6
          }

          this.chat = chat
          this.pendingChatListScroll = listScrollTop
          this.guardarConversacionesFast(conversaciones)
          this.restoreChatListScroll(listScrollTop)
          this.scrollMensajesAlFinal()
        }).catch(error => {
          const msg = error && error.response && error.response.data
            ? error.response.data.message
            : 'Error al abrir el chat'
          this.validarError(msg)
          this.restoreChatListScroll(listScrollTop)
          this.pendingChatListScroll = null
        }).finally(() => {
          this.cargarMensajes = false
        })
      },

      abrirPegar (event) {
        console.log(event)
      },

      activarFiltroTemperatura (tipo) {
        if (tipo == 'fuego') {
          this.filtroFuego = !this.filtroFuego
          this.filtroHielo = false
          return
        }

        this.filtroHielo = !this.filtroHielo
        this.filtroFuego = false
      },

      limpiarFiltros () {
        this.filtroMensajes = false
        this.filtroHielo = false
        this.filtroRecomendados = false
        this.filtroFuego = false
        this.filtroVistos = false
        this.etiqueta = null
        this.filtroTiempo = null
        this.filtroVendedora = null
        this.filtroSinProspecto = null
        this.filtroSinProspectoNoInteres = false
        this.filtroIncompletos = null
      },

      chatEstaActivo (chatW) {
        return this.chat && this.chat.usuario == chatW.usuario
      },

      nombreContacto (chatW) {
        return this.telefonoContacto(chatW)
      },

      tituloListaChat (chatW) {
        if (chatW && chatW.vendedor && chatW.vendedor.nombre) {
          return chatW.vendedor.nombre
        }
        return ''
      },

      subtituloListaChat (chatW) {
        if (!chatW) return ''
        return this.telefonoContacto(chatW)
      },

      telefonoContacto (chatW) {
        return String((chatW && chatW.usuario) || '').replace('whatsapp:+52', '')
      },

      async copiarTexto (texto, mensaje) {
        const valor = String(texto || '').trim()
        if (!valor) {
          return
        }

        try {
          if (navigator.clipboard && window.isSecureContext) {
            await navigator.clipboard.writeText(valor)
          } else {
            const input = document.createElement('textarea')
            input.value = valor
            input.setAttribute('readonly', '')
            input.style.position = 'fixed'
            input.style.opacity = '0'
            document.body.appendChild(input)
            input.select()
            document.execCommand('copy')
            document.body.removeChild(input)
          }

          this.validarSuccess(mensaje)
        } catch (error) {
          this.validarError('No se pudo copiar al portapapeles')
        }
      },

      resumenMensaje (chatW) {
        if (!chatW) {
          return ''
        }

        if (chatW.type == 2) {
          return 'Imagen'
        }

        if (chatW.type == 3) {
          return 'Audio'
        }

        if (chatW.type == 4) {
          return 'PDF'
        }

        if (chatW.type == 5) {
          return 'Video'
        }

        return chatW.mensaje || 'Sin mensajes'
      },

      horaChat (chatW) {
        return chatW.fecha_ultimo_mensaje || chatW.ultimmensaje || chatW.ultimomensaje || ''
      },

      chipCityColor (chat) {
        if (chat && chat.city) {
          if (chat.city == 'cdmx') {
            return 'pink accent-4'
          }
          if (chat.city == 'mty') {
            return 'deep-orange accent-3'
          }
          if (chat.city == 'gdl') {
            return 'teal accent-4'
          }
        }

        return 'teal darken-1'
      },

      tiempoColor (chatW) {
        if (chatW.tiemporestante > 2) {
          return '#00a884'
        }

        if (chatW.tiemporestante > 0) {
          return '#f2c94c'
        }

        return '#f15c6d'
      },
    },
  }
</script>

<style scoped>
  .twilio-whatsapp-shell {
    height: calc(100vh - 64px);
    height: calc(100dvh - 64px - env(safe-area-inset-top, 0px));
    min-height: 0;
    overflow: hidden;
    background: linear-gradient(180deg, #00a884 0 130px, #e4e1de 130px 100%);
    font-family: 'Poppins', sans-serif !important;
  }

  .twilio-whatsapp-app {
    height: 100%;
    margin: 0;
    overflow: hidden;
    border-radius: 3px;
    background: #f0f2f5;
  }

  .twilio-whatsapp-row {
    height: 100%;
    min-height: 0;
    flex-wrap: nowrap;
  }

  @media (min-width: 600px) {
    .twilio-whatsapp-row > .twilio-whatsapp-sidebar,
    .twilio-whatsapp-row > .twilio-whatsapp-conversation {
      flex: 0 0 50% !important;
      max-width: 50% !important;
    }
  }

  .twilio-whatsapp-sidebar {
    border-right: 1px solid #d1d7db;
    background: #ffffff;
    display: flex;
    flex-direction: column;
    height: 100%;
    min-height: 0;
  }

  .twilio-whatsapp-conversation {
    position: relative;
    display: flex;
    flex-direction: column;
    height: 100%;
    min-height: 0;
    background: #efeae2;
  }

  .wa-sidebar-header,
  .wa-chat-header {
    flex: 0 0 64px;
    height: 64px;
    background: #f0f2f5;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 16px;
    border-bottom: 1px solid #dce1e4;
  }

  .wa-header-actions {
    gap: 18px;
  }

  .wa-header-actions >>> .v-btn {
    margin-left: 14px !important;
  }

  .wa-title,
  .wa-chat-name {
    color: #111b21;
    font-weight: 600;
    line-height: 1.2;
  }

  .wa-chat-title-stack {
    display: flex;
    flex-direction: column;
    gap: 2px;
    min-width: 0;
  }

  .wa-copy-row {
    display: flex;
    align-items: center;
    gap: 6px;
    min-width: 0;
  }

  .wa-copy-btn {
    flex-shrink: 0;
  }

  .wa-chat-name {
    font-size: 16px;
    font-weight: 800;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .wa-chat-folio {
    color: #41525d;
    flex-shrink: 0;
    font-size: 13px;
    font-weight: 700;
  }

  .wa-subtitle,
  .wa-chat-meta,
  .wa-contact-middle {
    color: #667781;
    font-size: 12px;
    line-height: 1.3;
  }

  .wa-search-panel {
    flex: 0 0 auto;
    background: #ffffff;
    border-bottom: 1px solid #e9edef;
    padding: 10px 12px 8px;
  }

  .wa-search >>> .v-input__slot,
  .wa-select >>> .v-input__slot {
    background: #f0f2f5 !important;
    min-height: 38px !important;
  }

  .wa-filter-row,
  .wa-filter-actions {
    display: flex;
    align-items: center;
    gap: 8px;
    overflow-x: auto;
    padding-top: 10px;
  }

  .wa-filter-row {
    padding-bottom: 4px;
  }

  .wa-incompletos-select {
    min-width: 150px;
    max-width: 190px;
  }

  .wa-incompletos-select >>> .v-input__slot {
    min-height: 38px !important;
  }

  .wa-select-tooltip {
    margin-left: auto;
  }

  .wa-filter-btn,
  .wa-filter-clear {
    box-shadow: 0 6px 16px rgba(11, 20, 26, .16) !important;
  }

  .wa-filter-clear {
    background: #ffffff !important;
    color: #111b21 !important;
    font-weight: 600;
    letter-spacing: .08em;
    text-transform: uppercase;
  }

  .wa-filter-chip,
  .wa-menu-filter {
    border: 1px solid #e9edef !important;
    color: #54656f;
    text-transform: none;
  }

  .wa-chat-list {
    flex: 1 1 auto;
    min-height: 0;
    overflow-y: auto;
    background: #ffffff;
  }

  .wa-contact {
    display: flex;
    gap: 12px;
    min-height: 78px;
    padding: 12px 14px;
    cursor: pointer;
    border-bottom: 1px solid #f0f2f5;
    transition: background-color .15s ease;
  }

  .wa-contact:hover,
  .wa-contact-active {
    background: #f0f2f5;
  }

  .wa-contact-body {
    min-width: 0;
    flex: 1;
  }

  .wa-contact-top,
  .wa-contact-bottom {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
  }

  .wa-contact-name,
  .wa-last-message {
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .wa-contact-name {
    color: #111b21;
    font-size: 16px;
    font-weight: 700;
  }

  .wa-contact-time {
    color: #667781;
    flex-shrink: 0;
    font-size: 11px;
  }

  .wa-last-message {
    color: #667781;
    font-size: 13px;
  }

  .wa-contact-badges {
    display: flex;
    align-items: center;
    gap: 4px;
    flex-shrink: 0;
  }

  .wa-time-chip {
    font-weight: 700;
    letter-spacing: 0;
  }

  .wa-unread {
    min-width: 20px;
    height: 20px;
    padding: 0 6px;
    border-radius: 999px;
    background: #25d366;
    color: #ffffff;
    font-size: 11px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-weight: 700;
  }

  .wa-avatar-text {
    color: #54656f;
    font-size: 13px;
    font-weight: 700;
  }

  .wa-empty-state {
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    color: #667781;
    border-bottom: 6px solid #25d366;
    background: #f8f9fa;
  }

  .wa-empty-state h2 {
    margin: 18px 0 8px;
    color: #41525d;
    font-weight: 400;
  }

  .wa-empty-state p {
    max-width: 360px;
  }

  .wa-chat-actions {
    display: flex;
    align-items: center;
    gap: 4px;
    flex-shrink: 0;
  }

  .wa-action-btn {
    color: #54656f !important;
    text-transform: none;
  }

  .wa-chat-area {
    display: flex;
    flex: 1 1 auto;
    min-height: 0;
    background-color: #efeae2;
    background-image:
      linear-gradient(rgba(239, 234, 226, .92), rgba(239, 234, 226, .92)),
      url('/fondo_whatsapp.jpg');
    background-size: 420px;
  }

  .wa-messages-scroll {
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;
    height: 100%;
    min-height: 0;
    padding: 0 !important;
  }

  .messages-chat {
    min-height: 100%;
    display: flex;
    flex-direction: column;
    background: transparent !important;
  }

  .wa-chat-list::-webkit-scrollbar,
  #scroll-target::-webkit-scrollbar {
    width: 6px;
  }

  .wa-chat-list::-webkit-scrollbar-thumb,
  #scroll-target::-webkit-scrollbar-thumb {
    background-color: rgba(11, 20, 26, .25);
    border-radius: 10px;
  }

  .messages-chat >>> .v-card__text {
    flex: 1 0 auto;
    padding: 18px 56px 12px !important;
  }

  .messages-chat >>> .v-card__text > .row {
    margin: 0 !important;
  }

  .messages-chat >>> .v-card__text > .row > .col {
    padding: 0 !important;
  }

  .messages-chat >>> .v-card__text > .row > .col > span {
    display: block;
    width: 100%;
    clear: both;
  }

  .messages-chat >>> .message {
    display: flex !important;
    align-items: flex-start;
    margin-bottom: 8px !important;
    width: 100%;
    clear: both;
  }

  .messages-chat >>> .noresponse,
  .messages-chat >>> .response {
    display: flex;
    flex-direction: column;
    width: max-content;
    max-width: min(72%, 720px) !important;
    min-width: 0;
  }

  .messages-chat >>> .response {
    margin-left: auto !important;
    align-items: flex-end;
  }

  .messages-chat >>> .noresponse {
    margin-right: auto !important;
    align-items: flex-start;
  }

  .messages-chat >>> .text {
    display: block;
    width: max-content;
    min-width: 42px;
    max-width: 100%;
    margin: 0 !important;
    padding: 9px 12px !important;
    border-radius: 9px !important;
    box-shadow: 0 1px .5px rgba(11, 20, 26, .13);
    color: #111b21 !important;
    font-size: 14.5px;
    line-height: 1.45;
    overflow-wrap: break-word;
    word-break: normal;
    white-space: pre-wrap !important;
  }

  .messages-chat >>> .text img,
  .messages-chat >>> .text video,
  .messages-chat >>> .text embed {
    max-width: 100% !important;
  }

  .messages-chat >>> .audio {
    width: 320px !important;
    max-width: 100% !important;
  }

  .messages-chat >>> .response .text {
    background: #d9fdd3 !important;
  }

  .messages-chat >>> .noresponse .text {
    background: #ffffff !important;
  }

  
  .messages-chat >>> .time {
    color: #667781 !important;
    font-size: 11px !important;
    margin: 2px 4px 0 !important;
    float: none !important;
    line-height: 1.3;
    max-width: 100%;
  }

  .messages-chat >>> .response-time {
    float: none !important;
    margin-right: 4px !important;
    text-align: right;
  }

  .messages-chat >>> #sectionMessage {
    position: sticky !important;
    top: auto !important;
    bottom: 0 !important;
    left: 0 !important;
    z-index: 5;
    min-height: 64px;
    padding: 10px 16px !important;
    background: #f0f2f5;
    border-top: 1px solid #d1d7db;
  }

  .messages-chat >>> #sectionMessage .v-input__slot {
    box-shadow: none !important;
  }

  .messages-chat >>> textarea {
    color: #111b21 !important;
  }

  @media (max-width: 599px) {
    .twilio-whatsapp-shell {
      height: calc(100vh - 64px);
      height: calc(100dvh - 64px - env(safe-area-inset-top, 0px));
      min-height: 0;
      overflow: hidden;
    }

    .twilio-whatsapp-app,
    .twilio-whatsapp-row,
    .twilio-whatsapp-sidebar,
    .twilio-whatsapp-conversation {
      height: 100% !important;
      min-height: 0 !important;
    }

    .wa-panel-hidden {
      display: none !important;
    }

    .twilio-whatsapp-row > .twilio-whatsapp-conversation:not(.wa-panel-hidden) {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      z-index: 6;
      box-sizing: border-box;
      width: 100% !important;
      max-width: 100% !important;
      flex: 1 1 100% !important;
      height: 100vh !important;
      height: 100dvh !important;
      max-height: 100dvh !important;
      padding-top: env(safe-area-inset-top, 0px);
      padding-bottom: env(safe-area-inset-bottom, 0px);
      background: #efeae2;
      border-radius: 0;
    }

    .messages-chat >>> .v-card__text {
      padding: 14px 16px 8px !important;
    }

    .messages-chat >>> .noresponse,
    .messages-chat >>> .response {
      max-width: 88% !important;
    }
  }
</style>
